import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background: rgb(251, 251, 251);\n  border-radius: 10px;\n  border: 1px solid rgb(204, 207, 207);\n  color: rgb(54, 63, 65);\n  display: flex;\n  font-family: cursive;\n  font-size: 20px;\n  height: 46px;\n  overflow: hidden;\n  padding: 0 16px;\n  white-space: nowrap;\n  box-sizing: border-box;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 22px;\n  margin-bottom: 6px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background: rgb(236, 255, 225);\n  border-radius: 10px;\n  border: 1px dashed rgb(116, 201, 71);\n  color: rgb(116, 201, 71);\n  cursor: ", ";\n  display: flex;\n  font-weight: 600;\n  height: 46px;\n  justify-content: center;\n  position: relative;\n  user-select: none;\n  width: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 30px;\n  position: relative;\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import posed from 'react-pose';
import { Ink } from '../../Ink';
import styled from '../../utils/styling/styled-components';
import { STATIC_INPUT, TAP_INPUT } from '../../utils/testing/TestIDs';
var TAP_TO_SIGN = 'Tap to sign';
var Container = styled.div(_templateObject());
var Overlay = styled.div(_templateObject2()); // Working

var Button = styled(posed(Overlay)({
  closed: {
    opacity: 0
  }
}))(_templateObject3(), function (props) {
  return props.pose === 'closed' ? 'default' : 'pointer';
});
var Label = styled.label(_templateObject4(), function (props) {
  return props.theme.colors.slate;
});
var StaticInput = styled(Overlay)(_templateObject5());

var TapInput = function TapInput(_ref) {
  var _ref$buttonValue = _ref.buttonValue,
      buttonValue = _ref$buttonValue === void 0 ? TAP_TO_SIGN : _ref$buttonValue,
      label = _ref.label,
      onSign = _ref.onSign,
      signed = _ref.signed,
      value = _ref.value,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, null, label), /*#__PURE__*/React.createElement(Container, {
    className: className
  }, /*#__PURE__*/React.createElement(StaticInput, {
    key: "value",
    "data-testid": STATIC_INPUT
  }, value), /*#__PURE__*/React.createElement(Button, {
    "data-testid": TAP_INPUT,
    key: "button",
    onClick: onSign,
    pose: signed ? 'closed' : 'open'
  }, buttonValue, /*#__PURE__*/React.createElement(Ink, null))));
};

export { TapInput };